// extracted by mini-css-extract-plugin
export default {"container":"benefit-card_container__sxFa+","heading":"benefit-card_heading__v0cRM","message":"benefit-card_message__YB-6Z","icon":"benefit-card_icon__xf5R-"};